
import { Component, Prop, Vue } from "vue-property-decorator";
import { NotificationMixins, NotificationState, NotificationValidation, NotificationValidationMessages } from '@/mixins/NotificationMixin';

@Component
export default class NotificationSummary extends Vue {
    @Prop({ required: true }) notificationsToSend!: NotificationState[];
    @Prop({ required: true }) notificationValidationErrorsByTemplate!: Map<number, NotificationValidation>;

    public readonly validationMessages: typeof NotificationValidationMessages = NotificationValidationMessages;

    private isSkipped(notification: NotificationState): boolean {
        return !!notification.skipped;
    }

    private getValidation(notification: NotificationState): NotificationValidation | null {
        // Skipped notifications are valid by default
        if (notification.skipped) {
            return null;
        }

        const templateId = notification.notificationTemplate?.notificationTemplateId ?? 0;
        return this.notificationValidationErrorsByTemplate.get(templateId) || null;
    }

    private hasErrors(notification: NotificationState): boolean {
        const validation = this.getValidation(notification);
        if (!validation) {
            return false;
        }
        return NotificationMixins.methods.notificationHasErrors(validation);
    }

    private getTemplateName(notification: NotificationState): string {
        return (notification.notificationTemplate && notification.notificationTemplate.title) || 'No Template';
    }
}
